import { React, useState, useEffect } from "react";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import styles from "../../styles/styles";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { server } from "../../server";
import { toast } from "react-toastify";
import { RxAvatar } from "react-icons/rx";
import { CheckCircle } from 'lucide-react';
import { Country, State } from "country-state-city";
import { Store } from 'lucide-react';
import { Upload } from 'lucide-react';

const ShopCreate = () => {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState();
  const [phoneCountryCode, setCountryPhoneCode] = useState();
  const [address, setAddress] = useState("");
  const [zipCode, setZipCode] = useState();
  const [avatar, setAvatar] = useState();
  const [password, setPassword] = useState("");
  const [visible, setVisible] = useState(false);
  const [selectedDomain, setSelectedDomain] = useState('');
  const domainExtensions = ['medicop.shop', 'make-my.shop'];
  const [combinedValue, setCombinedValue] = useState('');
  const [country, setCountry] = useState("IN");
  const [province, setProvince] = useState("");
  const [city, setCity] = useState("");
  const [gstNumber, setGstNumber] = useState("")

  useEffect(() => {
    if (name && selectedDomain) {
      setCombinedValue(`${name}.${selectedDomain}`);
    } else {
      setCombinedValue('');
    }
  }, [name, selectedDomain]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const coords = await fetchLocation();
    const { latitude, longitude } = coords;
    // Reverse geocoding service to get the full address
    const API_KEY = "df0474e4d43c460dbfd027e0082e77e6"
    const locationResponse = ""
    const currentLocationResponse = "";
    try{
      const locationResponse = await axios.get(
        `https://api.opencagedata.com/geocode/v1/json?q=${latitude}+${longitude}&key=${API_KEY}`
      );
      const currentLocationResponse = locationResponse.data.results[0].formatted;
    }
    catch(error){
      const locationResponse = ""
      const currentLocationResponse = "";
    }

    axios
      .post(`${server}/shop/create-shop`, {
        name,
        domainExtensions: [ selectedDomain ] ,
        email,
        password,
        avatar,
        zipCode,
        address: {
          address: address,
          country: country,
          state: province,
          city: city,
          zipCode: zipCode
        },
        phoneNumber,
        gstNumber,
        phoneCountryCode,
        currentLocation: {
          latitude,
          longitude,
          address: currentLocationResponse,
        },
      })
      .then((res) => {
        toast.success(res.data.message);
        setName("");
        setEmail("");
        setPassword("");
        setAvatar();
        setZipCode();
        setAddress("");
        setPhoneNumber();
      })
      .catch((error) => {
        toast.error(error.response.data.message);
      });
  };

  const fetchLocation = () => {
    return new Promise((resolve, reject) => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => resolve(position.coords),
          (error) => reject(error)
        );
      } else {
        reject(new Error("Geolocation is not supported by this browser."));
      }
    });
  };

  const handleFileInputChange = (e) => {
    const reader = new FileReader();

    reader.onload = () => {
      if (reader.readyState === 2) {
        setAvatar(reader.result);
      }
    };

    reader.readAsDataURL(e.target.files[0]);
  };

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-[35rem]">
        <div className="bg-white shadow sm:rounded-lg p-6">
          <div className="flex justify-center">
            <Store className="h-12 w-12 text-blue-600" />
          </div>
          <div>
            <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
              Register as a Seller
            </h2>
            <p className="mt-2 text-center text-sm text-gray-600 max-w">
              Join our marketplace and start selling today
            </p>
          </div>
        </div>
      </div>
      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-[35rem]">
        <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
          <form className="space-y-6" onSubmit={handleSubmit}>

            <div className="flex flex-col items-center justify-center space-y-4 p-6 bg-white rounded-lg shadow-md border">
              {/* <label
                htmlFor="avatar"
                className="text-lg font-semibold text-gray-700"
              >
                Shop Picture
              </label> */}
              <div className="relative">
                <div className="relative h-24 w-24 rounded-full overflow-hidden border-2 border-gray-200 group">
                  {avatar ? (
                    <img
                      src={avatar}
                      alt="Shop avatar"
                      layout="fill"
                      objectFit="cover"
                      className="rounded-full"
                    />
                  ) : (
                    <div className="flex items-center justify-center h-full w-full bg-gray-100">
                      <RxAvatar className="h-16 w-16 text-gray-400" />
                    </div>
                  )}
                  <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-50 opacity-0 group-hover:opacity-100 transition-opacity duration-200">
                    <label htmlFor="file-input" className="cursor-pointer">
                      <div 
                        variant="ghost" 
                        size="icon"
                        className="text-white hover:text-white hover:bg-transparent"
                      >
                        <Upload className="h-8 w-8" />
                        <span className="sr-only">{avatar ? 'Change Picture' : 'Upload Picture'}</span>
                      </div>
                    </label>
                  </div>
                </div>
                <input
                  type="file"
                  name="avatar"
                  id="file-input"
                  accept="image/*"
                  onChange={handleFileInputChange}
                  className="sr-only"
                />
              </div>
              <p className="text-sm text-gray-500">
                {avatar ? 'Click on the image to change' : 'Click on the image to upload'}
              </p>
            </div>

            <div>
              <div>
                <label htmlFor="name" className="block text-sm font-medium text-gray-700">
                  Shop Name
                </label>
                <div className="mt-1 flex">
                  <input
                    type="name"
                    name="name"
                    required
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    className="appearance-none block w-2/3 px-3 py-2 border border-gray-300 rounded-l-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                  />
                  <select
                    id="domainExtension"
                    name="domainExtension"
                    required
                    value={selectedDomain}
                    onChange={(e) => setSelectedDomain(e.target.value)}
                    className="block w-1/3 px-3 py-2 border border-gray-300 rounded-r-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                  >
                    <option value="">Extensions</option>
                    {domainExtensions.map((domain) => (
                      <option key={domain} value={domain}>
                        {domain}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="flex items-center space-x-2 mt-2">
                <CheckCircle className="w-4 h-4 text-green-500" />
                <label htmlFor="combinedValue" className="text-sm font-medium text-gray-700">
                  Your shop URL is
                </label>
                <div className="text-sm text-green-500 underline font-bold">
                  { `https://${combinedValue}` || 'Please enter a shop name and select an extension'}
                </div>
              </div>
            </div>
            
            <div className="bg-gray-50 shadow pb-2 pl-2 pr-2 border">
              <div className="w-full max-w-4xl mx-auto pl-4 pr-4 pt-4">
                <label
                  htmlFor="address"
                  className="block text-sm font-medium text-gray-700"
                >
                  Address
                </label>
                <div className="mt-1">
                  <input
                    type="address"
                    name="address"
                    required
                    value={address}
                    onChange={(e) => setAddress(e.target.value)}
                    className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                  />
                </div>
              </div>
              
              <div className="w-full max-w-4xl mx-auto p-4">
                <div className="flex flex-col sm:flex-row sm:space-x-4 mb-4">
                  <div className="w-full sm:w-1/2 mb-4 sm:mb-0">
                    <label className="block text-sm font-medium text-gray-700 mb-2">State</label>
                    <select
                      className="w-full border h-10 rounded-md px-3 focus:outline-none focus:ring-2 focus:ring-blue-500"
                      value={province}
                      onChange={(e) => setProvince(e.target.value)}
                    >
                      <option value="">Select State</option>
                      {State &&
                        State.getStatesOfCountry(country).map((item) => (
                          <option key={item.isoCode} value={item.isoCode}>
                            {item.name}
                          </option>
                        ))}
                    </select>
                  </div>

                  <div className="w-full sm:w-1/2">
                    <label className="block text-sm font-medium text-gray-700 mb-2">Country</label>
                    <select
                      className="w-full border h-10 rounded-md px-3 focus:outline-none focus:ring-2 focus:ring-blue-500"
                      value={country}
                      onChange={(e) => setCountry(e.target.value)}
                    >
                      <option value="">Select Country</option>
                      {Country &&
                        Country.getAllCountries().map((item) => (
                          <option key={item.isoCode} value={item.isoCode}>
                            {item.name}
                          </option>
                        ))}
                    </select>
                  </div>
                </div>

                <div className="flex flex-col sm:flex-row sm:space-x-4">
                  <div className="w-full sm:w-1/2 mb-4 sm:mb-0">
                    <label
                      htmlFor="city"
                      className="block text-sm font-medium text-gray-700 mb-2"
                    >
                      City
                    </label>
                    <input
                      type="text"
                      id="city"
                      name="city"
                      required
                      value={city}
                      onChange={(e) => setCity(e.target.value)}
                      className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    />
                  </div>

                  <div className="w-full sm:w-1/2">
                    <label
                      htmlFor="zipCode"
                      className="block text-sm font-medium text-gray-700 mb-2"
                    >
                      Zip Code
                    </label>
                    <input
                      type="text"
                      id="zipCode"
                      name="zipCode"
                      required
                      value={zipCode}
                      onChange={(e) => setZipCode(e.target.value)}
                      className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    />
                  </div>
                </div>
                <div className="pt-5">
                  <label
                    htmlFor="phoneNumber"
                    className="block text-sm font-medium text-gray-700"
                  >
                    Phone Number
                  </label>
                  <div className="mt-1 flex">
                    <select
                      className="w-1/3 border-r-0 rounded-r-none border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                      value={country}
                      onChange={(e) => {setCountry(e.target.value); setCountryPhoneCode(e.target.value.isoCode) } }
                    >
                      <option value="">Country Code</option>
                      {Country &&
                        Country.getAllCountries().map((item) => (
                          <option key={item.isoCode} value={item.isoCode}>
                            +{item.phonecode}
                          </option>
                        ))}
                    </select>
                    <input
                      type="tel"
                      name="phoneNumber"
                      id="phoneNumber"
                      required
                      value={phoneNumber}
                      onChange={(e) => setPhoneNumber(e.target.value)}
                      className="appearance-none block w-2/3 rounded-l-none px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                      placeholder=""
                    />
                  </div>
                </div>
              </div>
            </div>
            
            <div>
              <label
                htmlFor="email"
                className="block text-sm font-medium text-gray-700"
              >
                Email address
              </label>
              <div className="mt-1">
                <input
                  type="email"
                  name="email"
                  autoComplete="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                />
              </div>
            </div>

            <div>
              <label
                htmlFor="password"
                className="block text-sm font-medium text-gray-700"
              >
                Password
              </label>
              <div className="mt-1 relative">
                <input
                  type={visible ? "text" : "password"}
                  name="password"
                  autoComplete="current-password"
                  required
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                />
                {visible ? (
                  <AiOutlineEye
                    className="absolute right-2 top-2 cursor-pointer"
                    size={25}
                    onClick={() => setVisible(false)}
                  />
                ) : (
                  <AiOutlineEyeInvisible
                    className="absolute right-2 top-2 cursor-pointer"
                    size={25}
                    onClick={() => setVisible(true)}
                  />
                )}
              </div>
            </div>

            <div>
                <label htmlFor="gstNumber" className="block text-sm font-medium text-gray-700">
                  GST Number
                </label>
                <div className="mt-1 flex">
                  <input
                    type="name"
                    name="gstNumber"
                    value={gstNumber}
                    placeholder="Optional"
                    onChange={(e) => setGstNumber(e.target.value)}
                    className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-l-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                  />
                </div>
            </div>

            <div>
              <button
                type="submit"
                className="group relative w-full h-[40px] flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700"
              >
                Submit
              </button>
            </div>
            <div className={`${styles.noramlFlex} w-full`}>
              <h4>Already have an account?</h4>
              <Link to="/shop-login" className="text-blue-600 pl-2">
                Sign in
              </Link>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ShopCreate;
